<template>
  <div>
    <span>{{total}}</span>
    <el-popover placement="bottom" width="400" trigger="click">
      <el-table
        stripe
        :data="stocks"
        size="mini"
        :header-cell-style="{background:'#D7D7D7',color:'#000'}"
        :row-style="{height:'30px'}"
      >
        <el-table-column width="120" property="warehouse" label="Warehouse"></el-table-column>
        <el-table-column width="60" align="right" property="stock" label="Stock"></el-table-column>
        <el-table-column width="80" align="right" property="inTransit" label="In Transit"></el-table-column>
        <el-table-column width="130" align="right" property="eta" label=" Most Recent ETA"></el-table-column>
        <div slot="empty">
          <span class="popover-table-empty-text">No Data</span>
        </div>
      </el-table>
      <div v-if="!this.isProductList && this.stocks.length != 0" class="stocks-3rd-box">
        <div class="stocks-3rd-text1">Stock in BNE's warehouse&nbsp;&nbsp;</div>
        <div class="stocks-3rd-text2">{{stock_3rd}}</div>
      </div>
      <el-button type="text" slot="reference">
        <i class="el-icon-arrow-down"></i>
      </el-button>
    </el-popover>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ColumnStockDropDownSingleStk',
  props: {
    rowId: {
      type: [String, Number],
      required: true
    },
    row: {
      type: Object,
      required: true
    }
  },
  created () {
    if (this.isProductList) {
      this.stocks = this.row.stocks
    } else {
      this.stocks = this.product(this.rowId).stocks
      this.stock_3rd = this.product(this.rowId).stock_3rdP || 0
      this.bus.$on(`product-selected-${this.rowId}`, product => {
        this.stocks = product.stocks
        this.stock_3rd = product.stock_3rdP || 0
      })
      this.bus.$on('order-line-changed', this.lineChangedCb)
    }
    // console.log(`data-refresh created ${this.rowId}`);
    this.bus.$on('data-refresh', this.dataFreshCb)
  },
  beforeDestroy () {
    this.bus.$off('data-refresh', this.dataFreshCb)
    if (!this.isProductList) {
      this.bus.$off(`product-selected-${this.rowId}`)
      this.bus.$off('order-line-changed', this.lineChangedCb)
    }
  },
  data () {
    return {
      stocks: [],
      stock_3rd: ''
    }
  },
  computed: {
    ...mapGetters({
      product: 'edit/lineProduct'
    }),
    // stocks() {
    //   return this.localProduct.stocks
    // },
    total () {
      return this.stocks.reduce((sum, stock) => {
        return sum + stock.stock
      }, 0)
    }
  },
  methods: {
    dataFreshCb () {
      // console.log(`data-fresh emit recieved`)
      if (this.isProductList) {
        this.stocks = this.row.stocks
      } else {
        this.stocks = this.product(this.rowId).stocks
        this.stock_3rd = this.product(this.rowId).stock_3rdP || 0
      }
    },
    lineChangedCb () {
      this.stocks = this.product(this.rowId).stocks
      this.stock_3rd = this.product(this.rowId).stock_3rdP || 0
    }
  },
  inject: {
    bus: {
      from: 'bus'
    },
    isProductList: {
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.stocks-3rd-box {
  display: flex;
  font-size: 12px;
  font-weight: bold;
  margin-top: 10px;
}
.stocks-3rd-text1 {
  color: black;
  padding: 8px 10px;
  background-color: #D7D7D7;
}
.stocks-3rd-text2 {
  padding: 8px 10px;
  color: #D82828;
  border: 1px solid #D7D7D7;
}
</style>
